import { HUBSPOT_FORMS } from "@/data/hubspot-forms";

export type EbookMeta = {
  slug: string;
  cover: string;
  formId: string;
};

export type LocalizedEbook = EbookMeta & {
  title: string;
  description: string;
  highlights?: string[];
  badge?: string;
};

type EbookContent = {
  title: string;
  description: string;
  highlights?: string[];
  badge?: string;
};

/** Matches next-intl's `t.raw`, scoped to the "ebooksData" namespace. */
export type EbookContentReader = (slug: string) => EbookContent;

export const EBOOKS: EbookMeta[] = [
  {
    slug: "guia-ayudas-subvenciones-autoconsumo-solar",
    formId: HUBSPOT_FORMS.ebookAyudas,
    cover: "/static/ebooks/ebook-guia-sobre-ayudas-y-subvenciones.webp",
  },
  {
    slug: "verdades-y-mentiras-sobre-la-energia-fotovoltaica",
    formId: HUBSPOT_FORMS.ebookVerdadesMentiras,
    cover: "/static/ebooks/ebook-verdades-y-mentiras-sobre-la-energia-fotovoltaica.webp",
  },
  {
    slug: "tu-instalacion-fotovoltaica-paso-a-paso",
    formId: HUBSPOT_FORMS.ebookPasoAPaso,
    cover: "/static/ebooks/ebook-tu-instalacion-fotovoltaica-paso-a-paso.webp",
  },
  {
    slug: "instalaciones-fotovoltaicas-una-gran-oportunidad-para-las-empresas",
    formId: HUBSPOT_FORMS.ebookOportunidadEmpresas,
    cover: "/static/ebooks/ebook-instalaciones-fotovoltaicas-empresas.webp",
  },
  {
    slug: "contratos-ppa-para-empresas",
    formId: HUBSPOT_FORMS.ebookPpaEmpresas,
    cover: "/static/ebooks/ebook-contratos-ppa-para-empresas.webp",
  },
];

export const getEbooks = (readContent: EbookContentReader): LocalizedEbook[] =>
  EBOOKS.map((ebook) => ({ ...ebook, ...readContent(ebook.slug) }));

export const getEbookBySlug = (
  readContent: EbookContentReader,
  slug: string,
): LocalizedEbook | undefined => {
  const meta = EBOOKS.find((ebook) => ebook.slug === slug);
  if (!meta) return undefined;
  return { ...meta, ...readContent(slug) };
};
